<template>
  <div class="cat-area">
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un juzgado</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id && tipo.Nombre == enumeraciones.tiposDeSelect.Todos.Nombre" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los juzgados</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todas.Id && tipo.Nombre == enumeraciones.tiposDeSelect.Todas.Nombre" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todas.Nombre}} las áreas</option>
        <option v-for="Area in Areas" :key="Area.AreaId" :value="Area.AreaId">{{Area.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'
  import axios from 'axios'

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        Areas: [],
        idDelModelo: null        
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object,
      filtrarPor: {
        type: Function,
        default: (areas) => { return areas }
      }
    },
    mounted() {
      //this.params = this.parametros
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;
      
      
      const params = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_PJ_Catalogo_Establecer001Area", params);
    },
    methods: {
      cargaCatalogoDeAreas: function() {
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba

        axios.post(api.conexion + api.PJ.catalogos.C001Areas, this.parametros)
          .then(respuesta => {
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.Areas = this.filtrarPor(respuesta.data.Areas);
              this.$emit("terminoDeCargarAreas",this.Areas);
              
              if(this.parametros.elementosAOmitir != undefined){
                this.Areas = this.Areas.filter(element => {                   
                  if(!this.parametros.elementosAOmitir.includes(element.AreaId))
                    return element;
                });
              }

              if(this.parametros.elementosAConservar != undefined && this.parametros.elementosAConservar != null  && this.parametros.elementosAConservar.length > 0){
                this.Areas = this.Areas.filter(element => {                  
                  if(this.parametros.elementosAConservar.includes(element.AreaId))
                    return element;
                });
              }

              if(this.tipo.Id == enumeraciones.tiposDeSelect.Ninguno.Id && this.Areas.length >= 1 && (!this.valorDefinido || this.valorDefinido <= 0))
              {
                this.idDelModelo = this.Areas[0].AreaId;
                this.elegirPrimerElemento(this.Areas[0].AreaId);
              }
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const params = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        let areaObj = this.obtenerAreaObj({ idArea: evento.target.value });
        this.$store.dispatch("A_PJ_Catalogo_Establecer001Area", params);
        this.$emit("valorParaElPadre", evento, areaObj);        
      },
      obtenerAreaObj: function({ idArea }) {
        let areaObj = this.Areas.find(a => a.AreaId == idArea);
        return areaObj;
        this.$emit("valorParaElPadre", evento);        
      },
      elegirPrimerElemento(id) {
        const parametros = {
          llave: this.idDelInput,
          valor: id
        }
        
        this.$store.dispatch("A_PJ_Catalogo_Establecer001Area", parametros);
        //{id: id, nombre: this.Areas[id].Nombre}  lo que regresa el emit debe camrbiarse por esto si se busca obtener también el nombre 
        this.$emit("valorParaElPadrePrimerElemento", id);
      }
    },
    created() {
      this.cargaCatalogoDeAreas();
    }
  }
</script>

<style>
.cat-area .form-control {
  background-color: white !important;
        color: black !important;
}
</style>



// WEBPACK FOOTER //
// src/components/PJ/Catalogos/001Area.vue